// ** Navigation sections imports
import domains from './domains'
// ** Merge & Export
export default [...domains ]
